/**
 * @generated SignedSource<<bf23a345422fae2de0fc195dfee8d350>>
 * @relayHash 3c2963a896f9ac591f5fb2936c1ded83
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 351c38d4204be4347504920dc67489a9b231b37872183d43398f22a7a61e6236

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiVersionDetailsQuery } from './uiVersionDetailsQuery.graphql';

const node: PreloadableConcreteRequest<uiVersionDetailsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "351c38d4204be4347504920dc67489a9b231b37872183d43398f22a7a61e6236",
    "metadata": {},
    "name": "uiVersionDetailsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
